/*
 * Copyright (c) 2019 brightlamp
 */

import { axiosInit } from './axiosSetup';

export default
{
    namespaced: true,
    state:
    {
        totalRecords: 0,
        orgs: [],
        totalPlrTestsForOrg: 0,
        totalNpcTestsForOrg: 0,
        endpointKeysVerified: false,
        privateKey: null,
        privateKeyUrl: null,
        logo: null
    },
    mutations:
    {
        SET_ORGS: (state, payload) =>
        {
            state.orgs = payload
        },
        SET_TOTAL_RECORDS: (state, payload) =>
        {
            state.totalRecords = payload
        },
        SET_ORG: (state, payload) =>
        {
            if (payload.editedIndex >= 0)
            {
                Object.assign(state.orgs[payload.editedIndex], payload.data)
            }
            else
            {
                state.orgs.push(payload.data)
            }
        },
        DELETE_ORG: (state, payload) =>
        {
            state.orgs.splice(payload.deleteIndex, 1)
        },
        SET_PLR_TEST_COUNT_FOR_ORG: (state, payload) =>
        {
            state.totalPlrTestsForOrg = payload
        },
        SET_NPC_TEST_COUNT_FOR_ORG: (state, payload) =>
        {
            state.totalNpcTestsForOrg = payload
        },
        SET_ENDPOINT_KEYS_VERIFIED: (state, payload) =>
        {
            state.endpointKeysVerified = payload
        },
        SET_PRIVATE_KEY: (state, payload) =>
        {
            state.privateKey = payload
        },
        SET_PRIVATE_KEY_URL: (state, payload) =>
        {
            state.privateKeyUrl = payload
        },
        SET_LOGO: (state, payload) =>
        {
            state.logo = payload
        }
    },
    actions:
    {
        GET_ORGS: async (context, payload) =>
        {
            const { sortBy, descending, page, itemsPerPage } = payload.pagination;
            const axios = await axiosInit();
            const response = await axios.get('/org',
            {
                params:
                {
                    name: payload.search,
                    page: page,
                    limit: -1 === itemsPerPage ? 2147483647 : itemsPerPage
                }
            });
            context.commit('SET_TOTAL_RECORDS', response.headers['max-count'] * 1);
            const orgs = response.data;
            for (let org of orgs)
            {
                org = processOrgResponse(org)
            }
            context.commit('SET_ORGS', orgs)
        },
        SET_ORG: async (context, payload) =>
        {
            const axios = await axiosInit();
            const response = await axios.post('/org', payload.data);
            payload.data = processOrgResponse(response.data);
            context.commit('SET_ORG', payload)
        },
        DELETE_ORG: async (context, payload) =>
        {
            const axios = await axiosInit();
            await axios.delete(`/org/${payload.orgId}`);
            context.commit('DELETE_ORG', payload)
        },
        GET_TEST_COUNT_FOR_ORG: async (context, payload) =>
        {
            context.commit('SET_PLR_TEST_COUNT_FOR_ORG', '0');
            context.commit('SET_NPC_TEST_COUNT_FOR_ORG', '0');
            const axios = await axiosInit();
            const response = await axios.get(`/org/${payload.orgId}/total-tests`);
            context.commit('SET_PLR_TEST_COUNT_FOR_ORG', response.data.totalPlrTests.toLocaleString())
            context.commit('SET_NPC_TEST_COUNT_FOR_ORG', response.data.totalNpcTests.toLocaleString())
        },
        SET_ENDPOINT_KEYS: async (context, payload) =>
        {
            const axios = await axiosInit();
            const response = await axios.post(`/org/${payload}/generate-endpoint-keys`, payload);
            context.commit('SET_ENDPOINT_KEYS_VERIFIED', true);
            context.commit('SET_PRIVATE_KEY', response.data.privateKey);
            context.commit('SET_PRIVATE_KEY_URL', response.data.privateKeyUrl)
        },
        VERIFY_ENDPOINT_KEYS: async (context, payload) =>
        {
            const axios = await axiosInit();
            try
            {
                const response = await axios.get(`/org/${payload}/verify-endpoint-keys`);

                context.commit('SET_ENDPOINT_KEYS_VERIFIED', true);
                context.commit('SET_PRIVATE_KEY', response.data.privateKey);
                context.commit('SET_PRIVATE_KEY_URL', response.data.privateKeyUrl)
            }
            catch (error)
            {
                if (404 === error.response.status)
                {
                    context.commit('SET_ENDPOINT_KEYS_VERIFIED', false)
                }
                else
                {
                    throw error
                }
            }
        },
        GET_LOGO_URL: async (context, payload) =>
        {
            const axios = await axiosInit();
            const response = await axios.get(`org/${payload.orgId}/org-logo-url`,
            {
                params:
                {
                    filename: payload.filename
                }
            });
            context.commit('SET_LOGO', response.data.url)
        },
        UPLOAD_LOGO: async (context, payload) =>
        {
            const axios = await axiosInit(true, true);
            await axios.put(payload.url, payload.file)
        }
    }
}

function processOrgResponse(org)
{
    org.type = org.parentId ? 'Child' : 'Top';
    org.parentName = org.parentName ? org.parentName : 'Self';
    if (org.parentId)
    {
        org.paymentCusId = 'N/A'
    }
    org.paymentSubId = org.paymentSubId ? org.paymentSubId : 'N/A';
    // If we have a payment end date, just show the date portion
    if (org.paymentSubEndDate)
    {
        // Format the payment end date and time
        const date = new Date(org.paymentSubEndDate);
        org.paymentSubEndDate = date.toLocaleString()
    }
    else
    {
        org.paymentSubEndDate = 'N/A'
    }
    // Format the creation date and time
    const date = new Date(org.createdAt);
    org.createdAt = date.toLocaleString();

    if (!org.telehealth)
    {
        org.telehealth = {emailSubject: '', emailBody: ''}
    }
    return org
}
